// extracted by mini-css-extract-plugin
export default {"container":"styles_container__CTav6","title":"styles_title__15FLU","icon":"styles_icon__0rOo5","label":"styles_label__Fmuid","content":"styles_content__HTtTt"};